<template src="./html/Index.html"></template>

<script>
	import swal from 'sweetalert2'
	import Datatable from './Datatable.vue'
	import Fav from './Fab'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'datatable': Datatable,
			'fab': Fav,
		},
		data () {
			return {
			}
		},
		methods: {
			reload() {
				this.$nextTick( () => this.$refs.datatable.reload())
			},
			destroy: function(budget) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/orders/' + budget.id)
							.then(response => {
								that.$refs.datatable.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								swal({
									title: response.statusText,
									text: response.body,
									type: "warning"
								});
							})
						})
					}
				}]).catch(swal.noop)
			},
			editOrContinue(response) {
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/budgets/' + response.body.data.id + '/edit')
				}).catch()
			},
			create (type) {
				this.$refs.create.open(type)
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/Index.vue